import { FC } from 'react';

import Loader from '@/assets/icons/Loader';

const LoadingSpinner: FC = () => {
  return (
    <div
      style={{
        height: '24px',
        animationName: 'loading',
        animationDuration: '1000ms',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
      }}
    >
      <Loader
        style={{ fill: 'var(--tractie-color-content-emphasis' }}
        height='24px'
        width='24px'
        data-testid='loader-icon'
      />
    </div>
  );
};

export default LoadingSpinner;
